import { Menu } from "@/types/menu";

const menuData: Menu[] = [
  {
    id: 1,
    title: "Home",
    path: "/",
    newTab: false,
  },
  {
    id: 2,
    title: "About",
    path: "/about",
    newTab: false,
  },
  {
    id: 3,
    title: "Pricing",
    path: "/pricing",
    newTab: false,
  },
  {
    id: 4,
    title: "Contact",
    path: "/contact",
    newTab: false,
  },
  {
    id: 5,
    title: "Convert",
    path: "/convert",
    newTab: false,
  },
  {
    id: 6,
    title: "Saved",
    path: "/saved",
    newTab: false,
  },
  /* {
    id: 7,
    title: "Pages",
    newTab: false,
    submenu: [
      {
        id: 61,
        title: "About Page",
        path: "/about",
        newTab: false,
      },
      {
        id: 62,
        title: "Pricing Page",
        path: "/pricing",
        newTab: false,
      },
      {
        id: 63,
        title: "Contact Page",
        path: "/contact",
        newTab: false,
      },
      {
        id: 66,
        title: "Sign Up Page",
        path: "/signup",
        newTab: false,
      },
      {
        id: 67,
        title: "Sign In Page",
        path: "/signin",
        newTab: false,
      },
    ],
  }, */
];
export default menuData;
